// ===== ツールデータ =====
export const TOOLS_DATA = [
  {
    id: 1,
    title: '点滴滴下数計算ツール',
    description: '輸液量・時間から1分あたりの滴下数を計算します。残量から終了時間も求められます。',
    category: '輸液・水分管理',
    available: true,
    page: 'tool_drip',
  },
  {
    id: 2,
    title: 'DESIGN-R\u00AEスコア算出ツール',
    description: '褥瘡の7項目を入力し、DESIGN-R\u00AE2020に基づく合計スコアと表記を算出します。',
    category: '褥瘡・栄養',
    available: true,
    page: 'tool_design_r',
  },
  {
    id: 3,
    title: '\u30D6\u30EC\u30FC\u30C7\u30F3\u30B9\u30B1\u30FC\u30EB\u7B97\u51FA\u30C4\u30FC\u30EB',
    description: '\u8925\u7621\u30EA\u30B9\u30AF\u306E6\u9805\u76EE\u3092\u5165\u529B\u3057\u3001\u30D6\u30EC\u30FC\u30C7\u30F3\u30B9\u30B1\u30FC\u30EB\u306E\u5408\u8A08\u30B9\u30B3\u30A2\u3068\u30EA\u30B9\u30AF\u5224\u5B9A\u3092\u7B97\u51FA\u3057\u307E\u3059\u3002',
    category: '褥瘡・栄養',
    available: true,
    page: 'tool_braden',
  },
  {
    id: 4,
    title: '\u610F\u8B58\u30EC\u30D9\u30EB\u8A55\u4FA1\u30C4\u30FC\u30EB\uFF08GCS\u30FBJCS\uFF09',
    description: 'GCS\uFF08E\u30BFV\u30BFM\uFF09\u306E\u5408\u8A08\u30B9\u30B3\u30A2\u7B97\u51FA\u3068\u91CD\u75C7\u5EA6\u5224\u5B9A\u3001JCS\u306E\u7C21\u6613\u8A55\u4FA1\u304C\u3067\u304D\u307E\u3059\u3002',
    category: 'バイタルサイン・急変',
    available: true,
    page: 'tool_consciousness',
  },
  {
    id: 5,
    title: '\u30D0\u30EB\u30F3\u30AB\u30C6\u30FC\u30C6\u30EB\u5C3F\u91CF\u5224\u5B9A\u30C4\u30FC\u30EB',
    description: '\u4F53\u91CD\u304B\u3089\u5FC5\u8981\u306A\u6642\u9593\u5C3F\u91CF\u306E\u76EE\u5B89\u3092\u8A08\u7B97\u3057\u3001\u5B9F\u6E2C\u5C3F\u91CF\u304C\u3042\u308C\u3070\u4E0D\u8DB3\u30FB\u4E4F\u5C3F\u30FB\u7121\u5C3F\u3092\u5224\u5B9A\u3057\u307E\u3059\u3002',
    category: '輸液・水分管理',
    available: true,
    page: 'tool_urine_output',
  },
  {
    id: 6,
    title: 'バーセルインデックス算出ツール',
    description: 'ADL評価の10項目を選択し、バーセルインデックス（Barthel Index）の合計スコアとADL自立度を算出します。',
    category: 'ADL・認知',
    available: true,
    page: 'tool_barthel',
  },
  {
    id: 7,
    title: 'NEWS2 スコア算出ツール',
    description: 'バイタルサイン7項目を入力し、NEWS2（早期警告スコア）の合計スコアとリスクレベル・対応の目安を算出します。',
    category: 'バイタルサイン・急変',
    available: true,
    page: 'tool_news',
  },
  {
    id: 9,
    title: 'HDS-R（長谷川式）スコア算出ツール',
    description: '認知症スクリーニングの9項目を入力し、HDS-Rの合計スコアとカットオフ判定を算出します。',
    category: 'ADL・認知',
    available: true,
    page: 'tool_hdsr',
  },
  {
    id: 10,
    title: 'HDS-R（長谷川式）V2 — 物品画像つき',
    description: 'HDS-Rの拡張版。問8の5つの物品を画像で表示→隠す→採点の流れをUI化しています。',
    category: 'ADL・認知',
    available: true,
    page: 'tool_hdsr_v2',
  },
  {
    id: 11,
    title: 'MNA-SF 栄養スクリーニングツール',
    description: '高齢者の栄養状態を6項目でスクリーニング。BMI自動算出・CC代替入力対応。スコアと判定をコピーできます。',
    category: '褥瘡・栄養',
    available: true,
    page: 'tool_mna_sf',
  },
  {
    id: 12,
    title: 'CAM せん妄スクリーニングツール',
    description: 'CAM（Confusion Assessment Method）の4項目でせん妄の可能性を評価します。判定結果と次のアクションをコピーできます。',
    category: 'ADL・認知',
    available: true,
    page: 'tool_cam',
  },
  {
    id: 16,
    title: 'Nu-DESC せん妄スコアツール',
    description: 'Nu-DESC（Nursing Delirium Screening Scale）の5項目でせん妄をスクリーニング。シフト毎の点数化で経時変化を追えます。',
    category: 'ADL・認知',
    available: true,
    page: 'tool_nudesc',
  },
  {
    id: 8,
    title: 'FiO2換算ツール',
    description: '酸素デバイスと流量からFiO2（吸入酸素濃度）の目安を算出します。ステップアップ・ダウンの提案つき。',
    category: 'バイタルサイン・急変',
    available: true,
    page: 'tool_fio2',
  },
  {
    id: 13,
    title: '消毒液の希釈計算ツール',
    description: '製品(ハイター・ピューラックス・ミルトン・ヒビテン・オスバン等)と用途を選び、作成量を入力すると原液量・水量・接触時間・注意事項が一発で出ます。',
    category: '感染対策',
    available: true,
    page: 'tool_disinfectant_dilution',
  },
  {
    id: 14,
    title: '褥瘡ログ',
    description: '対象者IDごとに、写真とDESIGN-R®2020評価で褥瘡の経過を時系列に記録できるツール。データはお使いの端末内にのみ保存され、PDFで書き出せます。',
    category: '褥瘡・栄養',
    available: true,
    externalUrl: 'https://pressure-ulcer-log.rnlab.workers.dev',
  },
  {
    id: 15,
    title: '創傷ログ',
    description: '褥瘡以外の創傷（スキンテア・術後創・外傷・下腿潰瘍・IADなど）の経過を、TIME概念に基づく観察項目で時系列に記録し、経過比較表とPDFで他職種への共有まで完結するツール。データはお使いの端末内にのみ保存されます。',
    category: '褥瘡・栄養',
    available: true,
    externalUrl: 'https://wound-log.rnlab.workers.dev',
  },
];
